import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NutritionFacadeService } from '@emm/management/services/nutrition-facade.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-nutrition-assignments-search',
    styleUrls: ['./nutrition-assignments-search.component.scss'],
    templateUrl: './nutrition-assignments-search.component.html',
    standalone: false
})
export class NutritionAssignmentsSearchComponent implements OnInit {

    selected: string;
    options = ['Location', 'Location Sets'];

    constructor(private nutritionFacade: NutritionFacadeService) {}

    ngOnInit(): void {
        this.selected = 'Location';
    }

    handleChange(option): void {
        this.selected = option;
        this.nutritionFacade.clearedLocation();
    }

}
